import { UntypedFormArray, UntypedFormGroup, Validators } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';

import { Injectable } from '@angular/core';
import { PledgeProductRead } from '@app/forms/subscription/definition/interface/Pledge';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  get owners() {
    return this.form.get('owners') as UntypedFormArray;
  }

  options: any = {};
  generate(entity: any) {
    let scpis: UntypedFormGroup[] = [];
    const products = entity;

    if (products && products.length) {
      for (let scpi of products) {
        const parametersGroup = this.formBuilder.group({
          pourcentageDeRemise: [
            !_.isNil(scpi.parameters.pourcentageDeRemise)
              ? scpi.parameters.pourcentageDeRemise * 100
              : 0,
            Validators.required,
          ],
        });

        const formConfig: FormConfig<PledgeProductRead & { parameters: any }> =
          {
            id: [scpi.id],
            type: [scpi.type],
            productId: [scpi.productId],
            productName: [scpi.productName],
            status: [scpi.status],
            parameters: parametersGroup,
          };

        const formBuilderGroup = this.formBuilder.group(formConfig, {});
        scpis.push(formBuilderGroup);
      }
    }

    let group = this.formBuilder.group({
      scpis: this.formBuilder.array(scpis, Validators.nullValidator),
    });

    this.form = group;
    return group;
  }

  get scpis() {
    return this.form.get('scpis') as UntypedFormArray;
  }
  extract() {
    const formValue = _.cloneDeep(this.form?.value?.scpis);

    const scpis = formValue?.map(scpi => {
      return {
        ...scpi,
        parameters: {
          ...scpi.parameters,
          pourcentageDeRemise: !_.isNil(scpi.parameters.pourcentageDeRemise)
            ? scpi.parameters.pourcentageDeRemise / 100
            : 0,
        },
      };
    });

    return { products: scpis };
  }
}
